export const MAPS_TO_CUSTOM = "custom";
export const MAPS_TO_SECTION = "section";

export const FIELD_SAVE_AS_OPTIONS = [
  { group: "Custom", value: MAPS_TO_CUSTOM, label: "Custom (store as extra data)" },

  // ── Customer ─────────────────────────────────────────────────────────
  // All destinations exist on flps_vendor_client (or route to custom_fields
  // via the customer.* default branch in applyAnswerToTarget).
  { group: "Customer", value: "customer.firstname",              label: "First name" },
  { group: "Customer", value: "customer.lastname",               label: "Last name" },
  { group: "Customer", value: "customer.phone",                  label: "Phone" },
  { group: "Customer", value: "customer.whatsapp_number",        label: "WhatsApp number" },
  { group: "Customer", value: "customer.alternate_phone",        label: "Alternate phone" },
  { group: "Customer", value: "customer.email",                  label: "Email" },
  { group: "Customer", value: "customer.address.address1",       label: "Address line 1" },
  { group: "Customer", value: "customer.address.address2",       label: "Address line 2" },
  { group: "Customer", value: "customer.address.landmark",       label: "Landmark" },
  { group: "Customer", value: "customer.address.city",           label: "City" },
  { group: "Customer", value: "customer.address.state",          label: "State" },
  { group: "Customer", value: "customer.address.zip",            label: "Pincode" },
  { group: "Customer", value: "customer.address.maps_url",       label: "Google Maps URL" },
  { group: "Customer", value: "customer.id_proof",               label: "ID proof (file)" },
  { group: "Customer", value: "customer.reference_source",       label: "Reference source" },
  { group: "Customer", value: "customer.services_interested_in", label: "Services interested in" },
  { group: "Customer", value: "customer.notes",                  label: "Notes" },
  { group: "Customer", value: "customer.signature",              label: "Customer signature" },
  { group: "Customer", value: "customer.wants_account",          label: "Create an account" },

  // ── Pet ──────────────────────────────────────────────────────────────
  // Entries that were pointing at non-existent schema fields have been
  // removed or rerouted. See inline notes.

  // Basic
  { group: "Pet", value: "pet.photo",             label: "Pet photo" },                // → pet.image
  { group: "Pet", value: "pet.name",              label: "Pet name" },
  { group: "Pet", value: "pet.pet_type",          label: "Pet type" },
  { group: "Pet", value: "pet.breed",             label: "Breed" },
  { group: "Pet", value: "pet.size",              label: "Size" },
  { group: "Pet", value: "pet.gender",            label: "Gender" },
  { group: "Pet", value: "pet.birthday",          label: "Date of birth" },
  { group: "Pet", value: "pet.age",               label: "Age" },
  { group: "Pet", value: "pet.weight_kg",         label: "Weight" },
  { group: "Pet", value: "pet.neutered_status",   label: "Neutered / spayed" },
  { group: "Pet", value: "pet.color",             label: "Color" },
  { group: "Pet", value: "pet.hair_type",         label: "Hair type" },
  { group: "Pet", value: "pet.hair_length",       label: "Hair length" },
  { group: "Pet", value: "pet.hair_color",        label: "Hair color" },              // → pet.color

  // Health — mapped to real destinations
  { group: "Pet", value: "pet.medical_conditions",         label: "Medical conditions" },   // → medical_condition[]
  { group: "Pet", value: "pet.custom_medical_condition",   label: "Custom medical condition" }, // → medical_condition[]
  { group: "Pet", value: "pet.has_medical_condition",      label: "Has medical condition" }, // gate question, not stored
  { group: "Pet", value: "pet.on_medication",              label: "On any medication" },   // gate question, not stored
  { group: "Pet", value: "pet.allergies",                  label: "Allergies" },           // → allergies[]
  { group: "Pet", value: "pet.special_care_instructions",  label: "Special care instructions" },
  { group: "Pet", value: "pet.behavior_notes",             label: "Behavior notes" },
  { group: "Pet", value: "pet.behaviour",                  label: "Pet behaviour" },       // → custom_fields

  // Medication — all fold into ongoing_medications[0]
  { group: "Pet", value: "pet.medication_name",         label: "Medication name" },
  { group: "Pet", value: "pet.medication_dosage",       label: "Medication dosage" },
  { group: "Pet", value: "pet.medication_dosage_unit",  label: "Medication dosage unit" },
  { group: "Pet", value: "pet.medication_time",         label: "Medication time" },
  { group: "Pet", value: "pet.medication_instructions", label: "Medication instructions" },
  { group: "Pet", value: "pet.medication_photo",        label: "Medication photo" },     // → ongoing_medications[0].documents[]

  // Vaccination
  { group: "Pet", value: "pet.vaccination_status",         label: "Vaccination status" },
  { group: "Pet", value: "pet.vaccinations",               label: "Vaccines administered" }, // → vaccinations[]
  { group: "Pet", value: "pet.vaccine",                    label: "Vaccine (record)" },      // → vaccination_records[].vaccine
  { group: "Pet", value: "pet.vaccine_given_on",           label: "Vaccine given on" },      // → vaccination_records[].date_given
  { group: "Pet", value: "pet.vaccine_next_due",           label: "Vaccine next due" },      // → vaccination_records[].next_due
  { group: "Pet", value: "pet.vaccine_notes",              label: "Vaccine notes" },         // → vaccination_records[].notes
  { group: "Pet", value: "pet.vaccine_document",           label: "Vaccination certificate" }, // → vaccination_records[].documents
  { group: "Pet", value: "pet.rabies_vaccination_date",    label: "Rabies vaccination date" },
  { group: "Pet", value: "pet.rabies_vaccination_image",   label: "Rabies vaccination image" },
  { group: "Pet", value: "pet.dhppi_vaccination_date",     label: "DHPP vaccination date" },
  { group: "Pet", value: "pet.dhppi_vaccination_image",    label: "DHPP vaccination image" },

  // Diet — folds into meals[0]
  { group: "Pet", value: "pet.meal_type",            label: "Diet / meal type" },     // → meal_type[]
  { group: "Pet", value: "pet.meals_per_day",        label: "Meals per day" },
  { group: "Pet", value: "pet.what_to_feed",         label: "What to feed" },         // → meals[0].name
  { group: "Pet", value: "pet.when_to_feed",         label: "When to feed" },         // → meals[0].time
  { group: "Pet", value: "pet.how_much_to_feed",     label: "How much to feed" },     // → meals[0].quantity
  { group: "Pet", value: "pet.feeding_instructions", label: "Feeding instructions" }, // → meals[0].notes
  { group: "Pet", value: "pet.custom_meal_notes",    label: "Custom meal notes" },    // → meals[0].notes
  { group: "Pet", value: "pet.hydration",            label: "Water / hydration" },    // → meals[0].notes
  { group: "Pet", value: "pet.walks_per_day",        label: "Walks per day" },

  // Documents
  { group: "Pet", value: "pet.document_vaccination",  label: "Vaccination document" },
  { group: "Pet", value: "pet.document_medical",      label: "Medical record (file)" },
  { group: "Pet", value: "pet.document_prescription", label: "Prescription (file)" },
  { group: "Pet", value: "pet.document_lab",          label: "Lab report (file)" },
  { group: "Pet", value: "pet.document_insurance",    label: "Insurance document" },
  { group: "Pet", value: "pet.document_other",        label: "Other pet documents" },
  { group: "Pet", value: "pet.signature",             label: "Pet signature" },

  // ── Consent ──────────────────────────────────────────────────────────
  // All stored on form.consent.answers[]. Not propagated to client/pet.
  { group: "Consent", value: "consent.declaration",             label: "Owner declaration" },
  { group: "Consent", value: "consent.emergency_vet",           label: "Emergency vet authorization" },
  { group: "Consent", value: "consent.emergency_contact",       label: "Emergency contact permission" },
  { group: "Consent", value: "consent.photo_video",             label: "Photo / video consent" },
  { group: "Consent", value: "consent.additional_instructions", label: "Additional instructions" },
  { group: "Consent", value: "consent.signature",               label: "Consent signature" },
  { group: "Consent", value: "consent.date",                    label: "Consent date" },
];

export const ALLOWED_MAPS_TO = new Set(
  FIELD_SAVE_AS_OPTIONS.map((o) => o.value).concat([MAPS_TO_SECTION]),
);

export const normalizeMapsTo = (raw) => {
  const v = String(raw || "").trim();
  if (!v) return MAPS_TO_CUSTOM;
  if (v === MAPS_TO_SECTION) return v;
  if (v === MAPS_TO_CUSTOM) return v;
  if (/^(customer|pet|consent)\.[a-zA-Z0-9_.]+$/.test(v)) return v;
  return MAPS_TO_CUSTOM;
};

export const newFieldUid = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `fld-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;